(function () {
  'use strict';

  function boot() {
    var root = document.querySelector('[data-flexlead-root]');
    if (!root) return;

    var modal = root.querySelector('[data-flexlead-modal]');
    var panel = root.querySelector('.flexlead__panel');
    var form = root.querySelector('form');
    var result = root.querySelector('[data-flexlead-result]');
    var isMagnet = root.getAttribute('data-flexlead-mode') === 'magnet';
    var step1 = root.querySelector('[data-flexlead-step="1"]');
    var step2 = root.querySelector('[data-flexlead-step="2"]');
    var step3 = root.querySelector('[data-flexlead-step="3"]');
    var next = root.querySelector('[data-flexlead-next]');
    var nextQuestions = root.querySelector('[data-flexlead-next-questions]');
    var submit = root.querySelector('[data-flexlead-submit]');
    var fill = root.querySelector('[data-flexlead-progress-fill]');
    var goalsField = root.querySelector('[data-flexlead-goals]');
    var goalCount = root.querySelector('[data-flexlead-goal-count]');
    var defaultInterest = root.getAttribute('data-flexlead-default-interest') || '';
    var pendingKey = 'flexlearn_lead_pending_v4';
    var scrollKey = 'flexlearn_lead_scroll_v4';
    var goalsKey = 'flexlearn_lead_goals_v4';
    var reportKey = 'flexlearn_readiness_report_v1';
    var firstTouchKey = 'flexlearn_attribution_first_v1';
    var lastTouchKey = 'flexlearn_attribution_last_v1';
    var lastFocus = null;
    var MAX_GOALS = 3;

    function safeGetSession(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } }
    function safeSetSession(key, value) { try { window.sessionStorage.setItem(key, value); } catch (e) {} }
    function safeRemoveSession(key) { try { window.sessionStorage.removeItem(key); } catch (e) {} }
    function safeGetLocal(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
    function safeSetLocal(key, value) { try { window.localStorage.setItem(key, value); } catch (e) {} }
    function uid() { return 'fl_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10); }
    function parseJson(value, fallback) { try { return JSON.parse(value); } catch (e) { return fallback; } }

    function currentAttribution() {
      var params = new URLSearchParams(window.location.search);
      var braid = params.get('gbraid') || params.get('wbraid') || '';
      return {
        landing_page: window.location.pathname + window.location.search,
        referrer: document.referrer || '',
        timestamp_utc: new Date().toISOString(),
        utm_source: params.get('utm_source') || '',
        utm_medium: params.get('utm_medium') || '',
        utm_campaign: params.get('utm_campaign') || '',
        utm_content: params.get('utm_content') || '',
        utm_term: params.get('utm_term') || '',
        gclid: params.get('gclid') || '',
        google_braid: braid,
        fbclid: params.get('fbclid') || '',
        msclkid: params.get('msclkid') || '',
        ttclid: params.get('ttclid') || '',
        li_fat_id: params.get('li_fat_id') || ''
      };
    }

    function hasAttributionSignal(touch) {
      return !!(touch.utm_source || touch.utm_medium || touch.utm_campaign || touch.utm_content || touch.utm_term ||
        touch.gclid || touch.google_braid || touch.fbclid || touch.msclkid || touch.ttclid || touch.li_fat_id || touch.referrer);
    }

    function rememberAttribution() {
      var now = currentAttribution();
      var first = parseJson(safeGetLocal(firstTouchKey) || 'null', null);
      var last = parseJson(safeGetLocal(lastTouchKey) || 'null', null);
      if (!first) {
        first = now;
        safeSetLocal(firstTouchKey, JSON.stringify(first));
      }
      if (!last || hasAttributionSignal(now)) {
        last = now;
        safeSetLocal(lastTouchKey, JSON.stringify(last));
      }
      return { first: first || now, last: last || now };
    }

    var attribution = rememberAttribution();

    function cleanValue(value) {
      return value == null || value === '' ? 'Not provided' : String(value);
    }

    function setMeta(key, value) {
      var el = root.querySelector('[data-flexlead-meta="' + key + '"]');
      if (el) el.value = cleanValue(value);
    }

    function setReportField(key, value) {
      var el = root.querySelector('[data-flexlead-report-field="' + key + '"]');
      if (el) el.value = cleanValue(value);
    }

    function visitorTimezone() {
      try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'Not provided'; } catch (e) { return 'Not provided'; }
    }

    function visitorLocalTime() {
      try {
        return new Intl.DateTimeFormat(undefined, {
          year: 'numeric', month: 'short', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          timeZoneName: 'short'
        }).format(new Date());
      } catch (e) { return new Date().toString(); }
    }

    function deviceCategory() {
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return 'Mobile';
      if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return 'Tablet';
      return 'Desktop';
    }

    function emailDomain() {
      var input = root.querySelector('#FlexLeadEmail');
      var email = input ? String(input.value || '').trim().toLowerCase() : '';
      var at = email.lastIndexOf('@');
      return at > 0 && at < email.length - 1 ? email.slice(at + 1) : '';
    }

    function populateLeadIntelligence(eventId) {
      attribution = rememberAttribution();
      var first = attribution.first || {};
      var last = attribution.last || {};

      setMeta('submission_page', window.location.pathname + window.location.search);
      setMeta('first_landing_page', first.landing_page);
      setMeta('first_referrer', first.referrer || 'Direct / unknown');
      setMeta('last_referrer', last.referrer || first.referrer || 'Direct / unknown');

      setMeta('last_utm_source', last.utm_source || first.utm_source);
      setMeta('last_utm_medium', last.utm_medium || first.utm_medium);
      setMeta('last_utm_campaign', last.utm_campaign || first.utm_campaign);
      setMeta('last_utm_content', last.utm_content || first.utm_content);
      setMeta('last_utm_term', last.utm_term || first.utm_term);

      setMeta('first_utm_source', first.utm_source);
      setMeta('first_utm_medium', first.utm_medium);
      setMeta('first_utm_campaign', first.utm_campaign);
      setMeta('first_utm_content', first.utm_content);
      setMeta('first_utm_term', first.utm_term);

      setMeta('gclid', last.gclid || first.gclid);
      setMeta('google_braid', last.google_braid || first.google_braid);
      setMeta('fbclid', last.fbclid || first.fbclid);
      setMeta('msclkid', last.msclkid || first.msclkid);
      setMeta('ttclid', last.ttclid || first.ttclid);
      setMeta('li_fat_id', last.li_fat_id || first.li_fat_id);

      setMeta('browser_language', navigator.language || (navigator.languages && navigator.languages[0]) || 'Not provided');
      setMeta('timezone', visitorTimezone());
      setMeta('visitor_local_time', visitorLocalTime());
      setMeta('submitted_utc', new Date().toISOString());
      setMeta('device', deviceCategory());
      setMeta('email_domain', emailDomain());
      setMeta('event_id', eventId || 'Not provided');
    }

    function selectedGoals() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-flexlead-goal]:checked')).map(function (el) { return el.value; });
    }

    function syncGoals() {
      var goals = selectedGoals();
      if (goalsField) goalsField.value = goals.join(' | ');
      if (goalCount) {
        goalCount.textContent = goals.length + ' / ' + MAX_GOALS + ' selected';
        goalCount.classList.toggle('is-max', goals.length === MAX_GOALS);
      }
      root.querySelectorAll('[data-flexlead-goal]').forEach(function (input) {
        input.disabled = goals.length >= MAX_GOALS && !input.checked;
      });
      return goals;
    }

    function saveGoals() {
      var goals = syncGoals();
      safeSetSession(goalsKey, JSON.stringify(goals));
      return goals;
    }

    function restoreGoals() {
      var saved = parseJson(safeGetSession(goalsKey) || '[]', []);
      if (!Array.isArray(saved)) saved = [];
      if (!isMagnet && !saved.length && defaultInterest) saved = [defaultInterest];
      root.querySelectorAll('[data-flexlead-goal]').forEach(function (input) {
        input.checked = saved.indexOf(input.value) !== -1;
      });
      syncGoals();
    }

    function addGoal(value) {
      if (!value || isMagnet) return;
      var goals = selectedGoals();
      if (goals.indexOf(value) !== -1 || goals.length >= MAX_GOALS) return;
      var inputs = root.querySelectorAll('[data-flexlead-goal]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === value) {
          inputs[i].checked = true;
          break;
        }
      }
      saveGoals();
    }

    function pushData(eventName, extras) {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: eventName, source_page: window.location.pathname };
      if (extras) Object.keys(extras).forEach(function (k) { payload[k] = extras[k]; });
      window.dataLayer.push(payload);
    }

    function showStep(n) {
      var steps = isMagnet ? [step1, step2, step3] : [step1, step2];
      steps.forEach(function (step, idx) { if (step) step.hidden = idx !== (n - 1); });
      var total = isMagnet ? 3 : 2;
      if (fill) fill.style.width = ((n / total) * 100) + '%';
      for (var i = 1; i <= total; i++) {
        var label = root.querySelector('[data-flexlead-progress-label="' + i + '"]');
        if (label) label.classList.toggle('is-active', i === n);
      }
      if (n > 1) saveGoals();
      if (n === 2) pushData(isMagnet ? 'flexlearn_readiness_quick_check' : 'flexlearn_form_step_2', { goals: selectedGoals().join(' | '), goal_count: selectedGoals().length });
      if (isMagnet && n === 3) pushData('flexlearn_readiness_details', { goals: selectedGoals().join(' | '), goal_count: selectedGoals().length });
    }

    function openModal(opts) {
      opts = opts || {};
      lastFocus = document.activeElement;
      if (opts.interest) addGoal(opts.interest);
      if (!opts.preserveStep) showStep(1);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('flexlead-lock');
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
        var focusTarget = root.querySelector('[data-flexlead-success] [data-flexlead-close]') || root.querySelector('[data-flexlead-goal]:checked') || root.querySelector('input, button, select');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
      pushData(isMagnet ? 'flexlearn_readiness_opened' : 'flexlearn_form_opened', { goals: selectedGoals().join(' | '), goal_count: selectedGoals().length });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('flexlead-lock');
      window.setTimeout(function () { modal.hidden = true; }, 220);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }

    function validateGoals() {
      var goals = selectedGoals();
      if (goals.length < 1) {
        var firstGoal = root.querySelector('[data-flexlead-goal]');
        if (firstGoal) firstGoal.focus();
        if (goalCount) {
          goalCount.textContent = 'Choose at least 1 priority';
          goalCount.classList.add('has-error');
          window.setTimeout(function () { goalCount.classList.remove('has-error'); syncGoals(); }, 1800);
        }
        return false;
      }
      return goals.length <= MAX_GOALS;
    }

    function selectedRadio(selector) {
      var el = root.querySelector(selector + ':checked');
      return el ? el.value : '';
    }

    function validateQuickQuestions() {
      if (!isMagnet) return true;
      var q1 = selectedRadio('[data-flexlead-q1]');
      var q2 = selectedRadio('[data-flexlead-q2]');
      var ok = true;
      ['tracking', 'onboarding'].forEach(function (key) {
        var group = root.querySelector('[data-flexlead-question-group="' + key + '"]');
        if (group) group.classList.remove('has-error');
      });
      if (!q1) {
        var g1 = root.querySelector('[data-flexlead-question-group="tracking"]');
        if (g1) g1.classList.add('has-error');
        ok = false;
      }
      if (!q2) {
        var g2 = root.querySelector('[data-flexlead-question-group="onboarding"]');
        if (g2) g2.classList.add('has-error');
        ok = false;
      }
      if (!ok) {
        var firstMissing = !q1 ? root.querySelector('[data-flexlead-q1]') : root.querySelector('[data-flexlead-q2]');
        if (firstMissing) firstMissing.focus();
      }
      return ok;
    }

    function validate(container) {
      if (!container) return true;
      var fields = container.querySelectorAll('input, select, textarea');
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].hasAttribute('data-flexlead-goal') || fields[i].hasAttribute('data-flexlead-q1') || fields[i].hasAttribute('data-flexlead-q2')) continue;
        if (!fields[i].checkValidity()) {
          fields[i].reportValidity();
          return false;
        }
      }
      return true;
    }

    function uniquePush(list, value) {
      if (value && list.indexOf(value) === -1) list.push(value);
    }

    function buildReadinessReport() {
      if (!isMagnet) return null;
      var tracking = selectedRadio('[data-flexlead-q1]');
      var onboarding = selectedRadio('[data-flexlead-q2]');
      var goals = selectedGoals();
      var trackingScores = {
        'Spreadsheets or paper': 45,
        'Another system': 75,
        'We don’t really track it': 20
      };
      var onboardingScores = {
        'Under 1 week': 85,
        '1 to 4 weeks': 60,
        'Over a month': 35
      };
      var score = Math.round(((trackingScores[tracking] || 50) + (onboardingScores[onboarding] || 50)) / 2);
      var band = score >= 75 ? 'Strong foundation' : (score >= 55 ? 'Growth opportunity' : 'High-impact opportunity');
      var summary = score >= 75
        ? 'You already have a solid base. The biggest opportunity is to connect the experience, data and follow-through.'
        : (score >= 55
          ? 'You have useful building blocks, with clear room to simplify administration and strengthen visibility.'
          : 'A few focused changes could remove significant manual work and give HR much clearer visibility.');

      var goalWins = {
        'Corporate Learning & Upskilling': 'Create role-based learning paths tied to real skill needs.',
        'Centralized LMS Management': 'Centralize assignments, reminders and completion tracking in one place.',
        'Training Analytics & Skill Gaps': 'Give HR live training dashboards and skill-gap visibility.',
        'Gamified & Engaging Content': 'Increase participation with challenges, progress and recognition.',
        'Onboarding & HR Automation': 'Standardize onboarding with role-based journeys and automated follow-ups.'
      };
      var wins = [];
      goals.forEach(function (goal) { uniquePush(wins, goalWins[goal]); });

      if (tracking === 'Spreadsheets or paper') uniquePush(wins, 'Replace spreadsheets with automated compliance tracking and audit-ready records.');
      if (tracking === 'We don’t really track it') uniquePush(wins, 'Create one reliable source of truth for mandatory training and certification status.');
      if (tracking === 'Another system') uniquePush(wins, 'Connect learning data to HR KPIs so reporting leads to action.');
      if (onboarding === 'Over a month') uniquePush(wins, 'Shorten ramp-up with role-based onboarding milestones and automated handoffs.');
      if (onboarding === '1 to 4 weeks') uniquePush(wins, 'Measure time-to-productivity and remove repeated onboarding admin.');
      if (onboarding === 'Under 1 week') uniquePush(wins, 'Protect fast onboarding quality with consistent content and progress analytics.');
      uniquePush(wins, 'Turn training completion data into actionable people-development insights.');
      uniquePush(wins, 'Reduce manual follow-up with automated reminders and manager visibility.');
      wins = wins.slice(0, 3);

      var winPointMap = {
        'Create role-based learning paths tied to real skill needs.': 8,
        'Centralize assignments, reminders and completion tracking in one place.': 12,
        'Give HR live training dashboards and skill-gap visibility.': 10,
        'Increase participation with challenges, progress and recognition.': 7,
        'Standardize onboarding with role-based journeys and automated follow-ups.': 12,
        'Replace spreadsheets with automated compliance tracking and audit-ready records.': 14,
        'Create one reliable source of truth for mandatory training and certification status.': 15,
        'Connect learning data to HR KPIs so reporting leads to action.': 10,
        'Shorten ramp-up with role-based onboarding milestones and automated handoffs.': 12,
        'Measure time-to-productivity and remove repeated onboarding admin.': 8,
        'Protect fast onboarding quality with consistent content and progress analytics.': 6,
        'Turn training completion data into actionable people-development insights.': 8,
        'Reduce manual follow-up with automated reminders and manager visibility.': 7
      };
      var runningScore = score;
      var winPoints = wins.map(function (win) {
        var raw = winPointMap[win] || 7;
        var available = Math.max(0, 95 - runningScore);
        var applied = Math.min(raw, available);
        runningScore += applied;
        return applied;
      });
      var projectedScores = [];
      var cumulative = score;
      winPoints.forEach(function (points) { cumulative += points; projectedScores.push(cumulative); });
      var projectedScore = projectedScores.length ? projectedScores[projectedScores.length - 1] : score;
      var uplift = projectedScore - score;

      var report = {
        tracking: tracking,
        onboarding: onboarding,
        score: score,
        band: band,
        summary: summary,
        wins: wins,
        win_points: winPoints,
        projected_scores: projectedScores,
        projected_score: projectedScore,
        uplift: uplift,
        goals: goals,
        created_at: new Date().toISOString()
      };
      setReportField('tracking', tracking);
      setReportField('onboarding', onboarding);
      setReportField('score', score + ' / 100');
      setReportField('band', band);
      setReportField('projected_score', projectedScore + ' / 100');
      setReportField('uplift', '+' + uplift + ' points');
      setReportField('wins', wins.join(' | '));
      setReportField('wins_points', wins.map(function (win, index) { return win + ' (+' + winPoints[index] + ' pts → ' + projectedScores[index] + '/100)'; }).join(' | '));
      safeSetSession(reportKey, JSON.stringify(report));
      return report;
    }

    function populateReportSuccess() {
      if (!isMagnet) return;
      var report = parseJson(safeGetSession(reportKey) || 'null', null);
      if (!report) return;
      var score = root.querySelector('[data-flexlead-report-score]');
      var band = root.querySelector('[data-flexlead-report-band]');
      var summary = root.querySelector('[data-flexlead-report-summary]');
      if (score) score.textContent = report.score;
      if (band) band.textContent = report.band;
      if (summary) summary.textContent = report.summary;
      var projected = root.querySelector('[data-flexlead-report-projected]');
      var uplift = root.querySelector('[data-flexlead-report-uplift]');
      if (projected) projected.textContent = report.projected_score || report.score;
      if (uplift) uplift.textContent = '+' + (report.uplift || 0) + ' pts';
      root.querySelectorAll('[data-flexlead-report-win]').forEach(function (el) {
        var index = parseInt(el.getAttribute('data-flexlead-report-win'), 10);
        if (report.wins && report.wins[index]) el.textContent = report.wins[index];
      });
      root.querySelectorAll('[data-flexlead-report-points]').forEach(function (el) {
        var index = parseInt(el.getAttribute('data-flexlead-report-points'), 10);
        if (report.win_points && typeof report.win_points[index] !== 'undefined') el.textContent = '+' + report.win_points[index] + ' pts';
      });
      root.querySelectorAll('[data-flexlead-report-after]').forEach(function (el) {
        var index = parseInt(el.getAttribute('data-flexlead-report-after'), 10);
        if (report.projected_scores && typeof report.projected_scores[index] !== 'undefined') el.textContent = report.projected_scores[index] + '/100 potential';
      });
      var ring = root.querySelector('.flexlead-report__score-ring');
      if (ring) ring.style.setProperty('--score', String(report.score));
    }

    function trackLeadOnce() {
      if (!result || result.getAttribute('data-success') !== 'true') return;
      var pending = parseJson(safeGetSession(pendingKey) || 'null', null);
      var eventId = pending && pending.eventId ? pending.eventId : uid();
      var sentKey = 'flexlearn_lead_sent_v5:' + eventId;
      if (safeGetSession(sentKey) === '1') {
        window.__openAILeadTracked = true;
        window.__openAILeadEventId = eventId;
        window.__openAILeadPending = false;
        return;
      }

      var goals = pending && Array.isArray(pending.goals) ? pending.goals : parseJson(safeGetSession(goalsKey) || '[]', []);
      var goalsText = goals.length ? goals.join(' | ') : (defaultInterest || 'Website contact');
      var firstTouch = (pending && pending.firstTouch) || attribution.first || {};
      var lastTouch = (pending && pending.lastTouch) || attribution.last || {};
      var report = (pending && pending.report) || parseJson(safeGetSession(reportKey) || 'null', null);

      if (!window.__flexlearnLeadDataLayerPushed) {
        pushData('flexlearn_lead_created', {
          event_id: eventId,
          lead_type: isMagnet ? 'training_readiness_snapshot' : 'website_contact',
          goals: goalsText,
          goal_count: goals.length,
          readiness_score: report && report.score ? report.score : '',
          readiness_band: report && report.band ? report.band : '',
          projected_readiness_score: report && report.projected_score ? report.projected_score : '',
          readiness_uplift: report && report.uplift ? report.uplift : '',
          utm_source: lastTouch.utm_source || firstTouch.utm_source || '',
          utm_medium: lastTouch.utm_medium || firstTouch.utm_medium || '',
          utm_campaign: lastTouch.utm_campaign || firstTouch.utm_campaign || '',
          first_utm_source: firstTouch.utm_source || '',
          first_utm_medium: firstTouch.utm_medium || '',
          first_utm_campaign: firstTouch.utm_campaign || '',
          first_landing_page: firstTouch.landing_page || '',
          original_referrer: firstTouch.referrer || ''
        });
        window.__flexlearnLeadDataLayerPushed = true;
      }

      window.__openAILeadEventId = eventId;
      if (window.__openAIConsentGranted !== true) {
        window.__openAILeadPending = true;
        window.__openAILeadTracked = false;
        return;
      }
      if (typeof window.oaiq !== 'function') {
        window.__openAILeadPending = true;
        window.__openAILeadTracked = false;
        return;
      }

      window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: eventId });
      window.__openAILeadTracked = true;
      window.__openAILeadPending = false;
      safeSetSession(sentKey, '1');
      safeRemoveSession(pendingKey);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-flexlearn-demo-open], a[href="#flexlearn-demo"]');
      if (!trigger) return;
      event.preventDefault();
      var interest = trigger.getAttribute('data-flexlearn-interest') || defaultInterest;
      openModal({ interest: interest });
    });

    root.querySelectorAll('[data-flexlead-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    if (panel) panel.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !modal.hidden) closeModal(); });

    root.querySelectorAll('[data-flexlead-goal]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (selectedGoals().length > MAX_GOALS) input.checked = false;
        saveGoals();
      });
    });

    root.querySelectorAll('[data-flexlead-q1], [data-flexlead-q2]').forEach(function (input) {
      input.addEventListener('change', function () {
        var group = input.closest('[data-flexlead-question-group]');
        if (group) group.classList.remove('has-error');
      });
    });

    if (next) next.addEventListener('click', function () {
      if (!validateGoals()) return;
      saveGoals();
      showStep(2);
    });

    if (nextQuestions) nextQuestions.addEventListener('click', function () {
      if (!validateQuickQuestions()) return;
      buildReadinessReport();
      showStep(3);
      var first = step3 && step3.querySelector('input');
      if (first) window.setTimeout(function () { first.focus(); }, 40);
    });

    root.querySelectorAll('[data-flexlead-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = parseInt(button.getAttribute('data-flexlead-back') || '1', 10);
        showStep(target);
      });
    });

    var printButton = root.querySelector('[data-flexlead-print]');
    if (printButton) printButton.addEventListener('click', function () { window.print(); });

    if (form) form.addEventListener('submit', function (event) {
      var currentContactStep = isMagnet ? step3 : step2;
      if (isMagnet && step3 && step3.hidden) {
        event.preventDefault();
        if (!validateGoals()) { showStep(1); return; }
        if (!validateQuickQuestions()) { showStep(2); return; }
        buildReadinessReport();
        showStep(3);
        return;
      }
      if (!isMagnet && step2 && step2.hidden) {
        event.preventDefault();
        if (validateGoals()) showStep(2);
        return;
      }
      if (!validateGoals() || (isMagnet && !validateQuickQuestions()) || !validate(currentContactStep)) {
        event.preventDefault();
        return;
      }

      var report = isMagnet ? buildReadinessReport() : null;
      var eventId = uid();
      var goals = saveGoals();
      populateLeadIntelligence(eventId);
      safeSetSession(scrollKey, String(window.scrollY || 0));
      safeSetSession(pendingKey, JSON.stringify({
        eventId: eventId,
        goals: goals,
        report: report,
        ts: Date.now(),
        source: window.location.pathname,
        firstTouch: attribution.first,
        lastTouch: attribution.last
      }));
      if (submit) { submit.disabled = true; submit.textContent = isMagnet ? 'Preparing…' : 'Sending…'; }
    });

    restoreGoals();
    populateLeadIntelligence('Not provided');
    populateReportSuccess();

    var hasSuccess = result && result.getAttribute('data-success') === 'true';
    var hasErrors = result && result.getAttribute('data-errors') === 'true';
    if (hasSuccess || hasErrors) {
      var savedScroll = parseInt(safeGetSession(scrollKey) || '', 10);
      if (!Number.isNaN(savedScroll)) window.requestAnimationFrame(function () { window.scrollTo(0, savedScroll); });
      safeRemoveSession(scrollKey);
      if (hasErrors) showStep(isMagnet ? 3 : 2);
      openModal({ preserveStep: hasErrors });
      populateReportSuccess();
      if (window.location.hash) {
        try { window.history.replaceState(null, document.title, window.location.pathname + window.location.search); } catch (e) {}
      }
    } else if (window.location.hash === '#flexlearn-demo') {
      openModal({ interest: defaultInterest });
      try { window.history.replaceState(null, document.title, window.location.pathname + window.location.search); } catch (e) {}
    }

    window.addEventListener('flexlearn:openai-consent', function (event) {
      if (event && event.detail && event.detail.granted === true) trackLeadOnce();
    });

    trackLeadOnce();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
